<template>
  <tutorial-layout
    title="OAUTH Interactive Tutorial"
    :referenceLinks="referenceLinks"
    :youtubeLinks="youtubeLinks"
  >
    <p slot="overview">
      OAUTH is the primary way for handling authentication from the client to the server.
    </p>
    <p slot="benefits">
      This tutorial is geared towards helping developers understand how to implement security within their own applications.

      
    </p>

    <h4>Here is what you need to know:</h4>
    <p>
      <ul>
        <li>This component implements the OAUTH PKCE Client flow.</li>
        <li>When using Azure you need to ensure that your app registration is configured for the url in your dev environment.</li>
        <li>Additionaly, ensure that the <b>Single Page Application</b> option is enabled.</li>
      </ul>
        
      </p>


    <v-card>
        <v-card-text>

            <h3>OAUTH Settings</h3>
            <v-row>
                <v-col sm="12">
                    <v-text-field filled outlined v-model="client_id" label="Client ID" clearable />
                    <v-text-field filled outlined v-model="scope" label="Scope" clearable />

                    <v-divider />

                    <v-row>
                      <v-col sm="12" md="6">
                        <v-text-field filled outlined v-model="authorize_url" label="Authorize URL" clearable />
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field filled outlined v-model="token_url" label="Token URL" clearable />
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field filled outlined v-model="logout_url" label="Logout URL" clearable />
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field filled outlined v-model="redirect_uri" label="Redirect URI" clearable />
                      </v-col>
                    </v-row>

                    <v-toolbar>
                      <v-btn @click="clearAllCredentials">Clear All Credentials</v-btn>
                      <v-switch v-model="debug" label="Debug" clearable hide-details/>
                      <v-spacer />
                      <v-switch v-model="autologin" label="Autologin" hint="Intentionally disabled for this tutorial." clearable hide-details disabled/>
                      <v-spacer />
                      <v-btn @click="login" color="primary">Start Login Process</v-btn>
                    </v-toolbar>

                </v-col>
                <v-col sm="12">
                    <!-- @credentials-new="storeCredentials" -->
                    <oauth-wrapper 
                    :credentials.sync="credentials"
                    :authorizeUrl="authorize_url" 
                    :tokenUrl="token_url" 
                    :logoutUrl="logout_url" 
                    :scope="scope" 
                    :client_id="client_id" 
                    :redirect_uri="redirect_uri" 
                    :loginIncrementor="loginIncrementor"
                    :autologin="autologin" :debug="debug">

                      <v-card slot="not-logged-in" color="warning">
                        <v-card-text>
                          <p>The current user is not logged in.</p>
                        </v-card-text>
                      </v-card>

                      <v-card color="success" dark>
                        <v-card-text>
                          <p>The current user IS logged in.</p>

                          <span>Access Token:</span>
                          <br />
                          <code v-if="credentials">
                            <pre>{{credentials}}</pre>
                          </code>

                          
                        </v-card-text>
                        <v-card-actions>
                          <v-toolbar dense color="transparent" flat>
                            <v-spacer />
                            <v-btn :href="globalLogoutUrl">Logout</v-btn>
                          </v-toolbar>
                        </v-card-actions>
                      </v-card>
            </oauth-wrapper>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </tutorial-layout>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import tutorialLayout from "../../components/tutorial-layout";

import appOauthMixin from "./app-oauth-mixin"

export default {
  name: "OauthTutorial",
  mixins: [uiView, appOauthMixin],
  components: {
    tutorialLayout,
  },
  props: {},
  watch: {
  },
  computed: {
    referenceLinks() {
      return [];
    },
    youtubeLinks() {
      return [];
    },
  },
};
</script>

<style lang="scss">
</style>
